/* eslint-disable */


import { ArrowLeft, ChevronLeft, FileDown, FileSpreadsheet } from 'lucide-react';
import AssetAllocationTable from './AssetAllocationTable';
import EquityBreakdownTable from './EquityBreakdownTable';
import AssetDonutChart from './AssetDonutChart';
import EquityCapChart from './EquityCapChart';
import { PortfolioAllocation } from '../../store/UserStore';
import { useRecoilValueLoadable } from 'recoil';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// // Mock API Response Data
// const apiData = {
//   asset: [
//     { category: 'Equity', amount: 4500000, percentage: 45 },
//     { category: 'Debt', amount: 3000000, percentage: 30 },
//     { category: 'Gold', amount: 1000000, percentage: 10 },
//     { category: 'Global Equity', amount: 1000000, percentage: 10 },
//     { category: 'Other', amount: 500000, percentage: 5 },
//   ],
//   equityCap: {
//     largeCapPercentage: 60,
//     midCapPercentage: 25,
//     smallCapPercentage: 15,
//   },
// };



const PortfolioAllocationDashboard = () => {
    const navigate = useNavigate()
    const portfolioAllocationData = useRecoilValueLoadable(PortfolioAllocation)

    const { state, contents } = portfolioAllocationData

    // Extract asset data from nested structure
    const assetData = contents?.asset?.result?.asset || []

    // Extract equityCap data from nested structure
    const equityCapResponse = contents?.equityCap?.result?.equityCap

    // Use equityCap data directly from API response
    const equityCapData = equityCapResponse ? {
        largeCap: {
            amount: equityCapResponse.largeCap || 0,
            percentage: equityCapResponse.largeCapPercentage || 0,
        },
        midCap: {
            amount: equityCapResponse.midCap || 0,
            percentage: equityCapResponse.midCapPercentage || 0,
        },
        smallCap: {
            amount: equityCapResponse.smallCap || 0,
            percentage: equityCapResponse.smallCapPercentage || 0,
        },
    } : {
        largeCap: { amount: 0, percentage: 0 },
        midCap: { amount: 0, percentage: 0 },
        smallCap: { amount: 0, percentage: 0 },
    };

    // const handleExportPDF = () => {
    //     console.log('Exporting to PDF...');
    // };

    // const handleExportExcel = () => {
    //     console.log('Exporting to Excel...');


    // };

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
                {/* Header */}
                <div className="mb-6 sm:mb-8">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                        <div className="flex items-center gap-4">

                            <div>
                                <Link to="/dashboard" className="flex items-center gap-2 text-xl sm:text-2xl mb-2 text-black-500">
                                    <ChevronLeft className="w-6 h-6 text-black-500 ml-[-8px]" />
                                    Portfolio Analytics
                                </Link>

                                <p className="text-sm sm:text-base text-gray-600">
                                    View detailed allocation analysis of your current investments.
                                </p>
                            </div>
                        </div>
                        {/* <div className="flex items-center gap-2 sm:gap-3">
                            <button
                                onClick={handleExportPDF}
                                className="flex items-center gap-2 px-3 sm:px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors shadow-sm"
                            >
                                <FileDown className="w-4 h-4" />
                                <span className="text-sm">PDF</span>
                            </button>
                            <button
                                onClick={handleExportExcel}
                                className="flex items-center gap-2 px-3 sm:px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors shadow-sm"
                            >
                                <FileSpreadsheet className="w-4 h-4" />
                                <span className="text-sm">Excel</span>
                            </button>
                        </div> */}
                    </div>
                </div>

                {/* Asset Allocation Section - Chart and Table Combined */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-4 sm:mb-6">
                    <div className="px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200">
                        <h2 className="text-base sm:text-lg">Asset Allocation Distribution</h2>
                    </div>
                    <div className="px-4 sm:px-6 py-4 sm:py-6">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                            {/* Chart - Top on mobile, Left on desktop */}
                            <div className="lg:order-1">
                                <AssetDonutChart assets={assetData} hideTitle={true} hideCard={true} />
                            </div>
                            {/* Table - Bottom on mobile, Right on desktop */}
                            <div className="lg:order-2">
                                <AssetAllocationTable assets={assetData} hideTitle={true} hideCard={true} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Equity Cap Section - Chart and Table Combined */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                    <div className="px-4 sm:px-6 py-3 sm:py-4 border-b border-gray-200">
                        <h2 className="text-base sm:text-lg">Equity Market Cap Distribution</h2>
                    </div>
                    <div className="px-4 sm:px-6 py-4 sm:py-6">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
                            {/* Chart - Top on mobile, Left on desktop */}
                            <div className="lg:order-1">
                                <EquityCapChart equityCapData={equityCapData} hideTitle={true} hideCard={true} />
                            </div>
                            {/* Table - Bottom on mobile, Right on desktop */}
                            <div className="lg:order-2">
                                <EquityBreakdownTable equityCapData={equityCapData} hideTitle={true} hideCard={true} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PortfolioAllocationDashboard;